import {
  START_ACTIVE_EDITING,
  STOP_ACTIVE_EDITING,
} from "../constants/ActionTypes";

export const startActiveEditing = () => ({ type: START_ACTIVE_EDITING });
export const stopActiveEditing = () => ({ type: STOP_ACTIVE_EDITING });
